import React from "react";
import {
  Box,
  Option,
  Select,
  Stack,
  Switch,
  Typography,
} from "@mui/joy";
import { OrgThemeSettings } from "../../../common/types";

interface BrandingSettingsProps {
  value: OrgThemeSettings;
  onChange: (settings: OrgThemeSettings) => void;
  disabled?: boolean;
}

const BrandingSettings: React.FC<BrandingSettingsProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <Stack spacing={2}>
    <Box>
      <Typography level="title-sm" sx={{ fontWeight: 600, mb: 0.5 }}>
        Default Mode
      </Typography>
      <Typography level="body-xs" color="neutral" sx={{ mb: 1 }}>
        The colour mode shown to users on first visit.
      </Typography>
      <Select
        size="sm"
        value={value.default_mode}
        onChange={(_e, v) => v && onChange({ ...value, default_mode: v as OrgThemeSettings["default_mode"] })}
        disabled={disabled}
        sx={{ maxWidth: 200 }}
      >
        <Option value="light">Light</Option>
        <Option value="dark">Dark</Option>
        <Option value="system">System (follow OS)</Option>
      </Select>
    </Box>

    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
      <Switch
        checked={value.allow_user_theme_override}
        onChange={(e) => onChange({ ...value, allow_user_theme_override: e.target.checked })}
        disabled={disabled}
        sx={{ mt: 0.25 }}
      />
      <Box>
        <Typography level="body-md">Allow users to change colour mode</Typography>
        <Typography level="body-sm" color="neutral">
          When disabled, all members see the default mode and cannot switch between light and
          dark.
        </Typography>
      </Box>
    </Box>
  </Stack>
);

export default BrandingSettings;
